import { render, staticRenderFns } from "./TaxRatesList.vue?vue&type=template&id=2baab4fc&"
import script from "./TaxRatesList.vue?vue&type=script&lang=js&"
export * from "./TaxRatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports